import { Link, useParams } from "react-router-dom";
import { TEMPO_CONDICOES, type DiarioDetalhe, type TempoCondicao, type TipoItem } from "../../../shared/diario";
import { useDiario } from "../api/diarios";
import { Carregando, ErroCarregamento } from "../components/ui";

function fmt(iso: string | null): string {
  if (!iso) return "";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}

function Check({ on }: { on: boolean }) {
  return <span className="folha-box">{on ? "✕" : ""}</span>;
}

function LinhaTempo({ periodo, val }: { periodo: string; val: TempoCondicao | null }) {
  return (
    <tr>
      <td className="folha-lab" style={{ width: 80, textAlign: "center" }}>{periodo}</td>
      <td>
        {TEMPO_CONDICOES.map((n) => (
          <span key={n} className="folha-tempo-op"><Check on={val === n} /> {n}</span>
        ))}
      </td>
    </tr>
  );
}

export function DiarioImprimir() {
  const { id } = useParams();
  const consulta = useDiario(Number(id));

  if (consulta.isLoading) return <Carregando />;
  if (consulta.error || !consulta.data) return <ErroCarregamento erro={consulta.error} />;
  const d: DiarioDetalhe = consulta.data;

  const itensDe = (tipo: TipoItem) => d.itens.filter((it) => it.tipo === tipo && it.quantidade > 0);
  const eq = itensDe("equipamento");
  const mo = itensDe("mao_obra");
  const ef = itensDe("equipe_fiscalizacao");
  const nlin = Math.max(eq.length, mo.length, 1);

  return (
    <div className="folha-page">
      <div className="folha-acoes no-print">
        <Link className="btn" to={`/diarios/${d.id}`}>‹ Voltar ao diário</Link>
        <button className="btn primary" onClick={() => window.print()}>🖨️ Imprimir / Salvar PDF</button>
      </div>

      <div className="folha">
        <table>
          <tbody>
            <tr>
              <td className="folha-titulo" style={{ width: "70%" }}>DIÁRIO DE OBRA</td>
              <td className="folha-rotdir">Nº: {d.numero}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center", fontSize: 11, color: "#555", borderTop: "none", paddingTop: 0 }}>
                Relatório diário de acompanhamento de obra
              </td>
              <td className="folha-rotdir">DATA: {fmt(d.data)}</td>
            </tr>
          </tbody>
        </table>

        <table style={{ marginTop: -1 }}>
          <tbody>
            <tr>
              <td className="folha-lab">OBRA:</td><td colSpan={5}>{d.obra}</td>
            </tr>
            <tr>
              <td className="folha-lab">ORDEM DE SERVIÇO:</td><td colSpan={5}>{d.ordem_servico ? "Documento PDF anexado" : ""}</td>
            </tr>
            <tr>
              <td className="folha-lab">EMPRESA CONTRATADA:</td><td colSpan={3}>{d.empresa_contratada}</td>
              <td className="folha-lab">Nº CONTRATO:</td><td>{d.numero_contrato}</td>
            </tr>
            <tr>
              <td className="folha-lab">DATA INÍCIO:</td><td>{fmt(d.data_inicio)}</td>
              <td className="folha-lab">DATA FINAL:</td><td>{fmt(d.data_final)}</td>
              <td className="folha-lab">PRAZO / DIAS:</td><td>{d.prazo_dias} / {d.dias_corridos}</td>
            </tr>
          </tbody>
        </table>

        <table style={{ marginTop: -1 }}>
          <tbody>
            <tr>
              <td className="folha-sec" style={{ width: "50%" }}>SERVIÇOS EXECUTADOS</td>
              <td className="folha-sec">OBSERVAÇÕES A SEREM FEITAS PELA FISCALIZAÇÃO NO SERVIÇO EXECUTADO</td>
            </tr>
            <tr>
              <td className="folha-caixa" style={{ whiteSpace: "pre-wrap" }}>{d.servicos_executados}</td>
              <td className="folha-caixa" style={{ whiteSpace: "pre-wrap" }}>{d.observacoes_fiscalizacao}</td>
            </tr>
            <tr>
              <td className="folha-obs"><strong>Observação: </strong>{d.observacao_contratada}</td>
              <td className="folha-obs"><strong>Observação: </strong>{d.observacao_fiscalizacao_rodape}</td>
            </tr>
          </tbody>
        </table>

        <table style={{ marginTop: -1 }}>
          <tbody>
            <tr><td className="folha-sec" colSpan={2}>TEMPO</td></tr>
            <LinhaTempo periodo="MANHÃ" val={d.tempo_manha} />
            <LinhaTempo periodo="TARDE" val={d.tempo_tarde} />
          </tbody>
        </table>

        <table style={{ marginTop: -1 }}>
          <tbody>
            <tr>
              <td className="folha-sec">EQUIPAMENTOS UTILIZADOS</td><td className="folha-qcell folha-sec">QUANT.</td>
              <td className="folha-sec">MÃO-DE-OBRA</td><td className="folha-qcell folha-sec">QUANT.</td>
            </tr>
            {Array.from({ length: nlin }).map((_, i) => (
              <tr key={i}>
                <td>{eq[i]?.nome ?? ""}</td><td className="folha-qv">{eq[i] ? eq[i].quantidade : ""}</td>
                <td>{mo[i]?.nome ?? ""}</td><td className="folha-qv">{mo[i] ? mo[i].quantidade : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {ef.length > 0 && (
          <table style={{ marginTop: -1 }}>
            <tbody>
              <tr><td className="folha-sec">EQUIPE DA FISCALIZAÇÃO</td><td className="folha-qcell folha-sec">QUANT.</td></tr>
              {ef.map((x, i) => (
                <tr key={i}><td>{x.nome}</td><td className="folha-qv">{x.quantidade}</td></tr>
              ))}
            </tbody>
          </table>
        )}

        {d.fotos.length > 0 && (
          <>
            <table style={{ marginTop: -1 }}><tbody><tr><td className="folha-sec">REGISTRO FOTOGRÁFICO</td></tr></tbody></table>
            <div className="folha-fotos">
              {d.fotos.map((f, i) => (
                <div key={i} className="folha-fcard">
                  {f.url && <img src={f.url} alt={f.legenda} />}
                  <div className="folha-fl">{f.legenda}</div>
                </div>
              ))}
            </div>
          </>
        )}

        <table style={{ marginTop: 8, border: "none" }}>
          <tbody>
            <tr style={{ border: "none" }}>
              <td style={{ border: "none", width: "50%" }}>
                <div className="folha-assbox">
                  {d.assinatura_responsavel_img && <img src={d.assinatura_responsavel_img} alt="" />}
                  <div className="folha-assline" />
                  <div className="folha-assnome">{d.assinatura_responsavel_nome}</div>
                </div>
                <div className="folha-assrot" style={{ textAlign: "center" }}>ASSINATURA DO RESPONSÁVEL</div>
              </td>
              <td style={{ border: "none" }}>
                <div className="folha-assbox">
                  {d.assinatura_fiscal_img && <img src={d.assinatura_fiscal_img} alt="" />}
                  <div className="folha-assline" />
                  <div className="folha-assnome">{d.assinatura_fiscal_nome}</div>
                </div>
                <div className="folha-assrot" style={{ textAlign: "center" }}>ASS. FISCAL</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
